export default "__VITE_ASSET__CLi1k_F___"